import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mt-4 h-100 w-100" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header bg-primary text-white" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_11 = { class: "d-flex gap-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogView = _resolveComponent("LogView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString($setup.isEditing ? 'Edit Bank Account' : 'Add Bank Account'), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitForm && $setup.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              for: "accountTitle",
              class: "form-label"
            }, "Account Title", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': $setup.errors.accountTitle }]),
              id: "accountTitle",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.accountTitle) = $event)),
              required: ""
            }, null, 2), [
              [_vModelText, $setup.form.accountTitle]
            ]),
            ($setup.errors.accountTitle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.errors.accountTitle), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "sortCode",
              class: "form-label"
            }, "Sort Code", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': $setup.errors.sortCode }]),
              id: "sortCode",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.sortCode) = $event)),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.formatSortCode && $setup.formatSortCode(...args))),
              placeholder: "00-00-00",
              maxlength: "8",
              required: ""
            }, null, 34), [
              [_vModelText, $setup.form.sortCode]
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("small", { class: "form-text text-muted" }, "Format: 00-00-00 (6 digits)", -1)),
            ($setup.errors.sortCode)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.errors.sortCode), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[10] || (_cache[10] = _createElementVNode("label", {
              for: "accountNumber",
              class: "form-label"
            }, "Account Number", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid': $setup.errors.accountNumber }]),
              id: "accountNumber",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.accountNumber) = $event)),
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.formatAccountNumber && $setup.formatAccountNumber(...args))),
              placeholder: "12345678",
              maxlength: "8",
              required: ""
            }, null, 34), [
              [_vModelText, $setup.form.accountNumber]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("small", { class: "form-text text-muted" }, "8-digit account number", -1)),
            ($setup.errors.accountNumber)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.errors.accountNumber), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_11, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary",
              disabled: $setup.loading
            }, [
              ($setup.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString($setup.loading ? 'Saving...' : ($setup.isEditing ? 'Update' : 'Save')), 1)
            ], 8, _hoisted_12),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
            }, " Cancel ")
          ]),
          ($setup.message)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["alert mt-3", $setup.messageType]),
                role: "alert"
              }, _toDisplayString($setup.message), 3))
            : _createCommentVNode("", true)
        ], 32),
        ($setup.bankAccountId > 0)
          ? (_openBlock(), _createBlock(_component_LogView, {
              key: 0,
              baseUrl: $props.baseUrl,
              entityType: 'SecurityOfficerBankAccount',
              entityId: $setup.bankAccountId
            }, null, 8, ["baseUrl", "entityId"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}